export default "__VITE_ASSET__CTrUFZuf__"